import React from "react";
import barpannel from "../../style/components/bars/Bars.module.css";
import Settingspannel from "../../style/components/bars/SettingsBar.module.css";
import { PiUserListLight } from "react-icons/pi";
import { GoOrganization } from "react-icons/go";
import { GrGroup } from "react-icons/gr";
import { LuUserPlus } from "react-icons/lu";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { Link, useLocation } from "react-router-dom";
import { CgHashtag } from "react-icons/cg";
import { TbLogs } from "react-icons/tb";
import { LuLayoutDashboard } from "react-icons/lu";

import {
  getAccessCondition,
  getSelectedCompany,
  getUserDetails,
} from "../../utils/auth";
import { MdOutlinePrivacyTip } from "react-icons/md";

const SettingsBar = () => {
  const access_details = getAccessCondition() || [];
  const role = getUserDetails() || [];
  const checkCondition = access_details.access_details;
  // console.log("access_details", access_details.access_details.employee);
  const location = useLocation(); // current route
  const selectedCompany = getSelectedCompany();
  const accessCompany = access_details?.access_company || [];

  const isSelected = (path) => location.pathname.startsWith(path);
  const hasCompanyAccess =
    role.role === "other_user" && selectedCompany
      ? accessCompany.includes(selectedCompany.id)
      : true;
  return (
    <div className={barpannel.BarsContainer}>
      <div className={barpannel.BarsContainerChild}>
        <div className={Settingspannel.settingsBarHeadContent}>
          <h2>Settings</h2>
        </div>
        <div className={Settingspannel.settingsListContainer}>
          <ul className={Settingspannel.settingsList}>
            <Link to="/accountsummary">
              <li
                className={`${Settingspannel.settingsListItem} ${
                  isSelected("/accountsummary")
                    ? Settingspannel.selectedItem
                    : ""
                }`}
              >
                <LuLayoutDashboard />
                Account Summary
              </li>
            </Link>
            {role.role === "admin" ? (
              <>
                <Link to="/userlist">
                  <li
                    className={`${Settingspannel.settingsListItem} ${
                      isSelected("/userlist") ? Settingspannel.selectedItem : ""
                    }`}
                  >
                    <PiUserListLight />
                    User List
                  </li>
                </Link>

                <Link to="/group">
                  <li
                    className={`${Settingspannel.settingsListItem} ${
                      isSelected("/group") ? Settingspannel.selectedItem : ""
                    }`}
                  >
                    {" "}
                    <GrGroup />
                    Groups
                  </li>
                </Link>
                <Link to="/channel">
                  <li
                    className={`${Settingspannel.settingsListItem} ${
                      isSelected("/channel") ? Settingspannel.selectedItem : ""
                    }`}
                  >
                    {" "}
                    <CgHashtag />
                    Channel
                  </li>
                </Link>
                <Link to="/userandrole">
                  <li
                    className={`${Settingspannel.settingsListItem} ${
                      isSelected("/userandrole")
                        ? Settingspannel.selectedItem
                        : ""
                    }`}
                  >
                    <LuUserPlus />
                    User and Access
                  </li>
                </Link>
                <Link to="/logs">
                  <li
                    className={`${Settingspannel.settingsListItem} ${
                      isSelected("/logs") ? Settingspannel.selectedItem : ""
                    }`}
                  >
                    {" "}
                    <TbLogs />
                    Logs
                  </li>
                </Link>
                <Link to="/companylist">
                  <li
                    className={`${Settingspannel.settingsListItem} ${
                      isSelected("/companylist")
                        ? Settingspannel.selectedItem
                        : ""
                    }`}
                  >
                    {" "}
                    <GoOrganization />
                    Companies
                  </li>
                </Link>
              </>
            ) : role.role === "other_user" && hasCompanyAccess ? (
              <>
                {checkCondition?.user?.includes("view") && (
                  <Link to="/userlist">
                    <li
                      className={`${Settingspannel.settingsListItem} ${
                        isSelected("/userlist")
                          ? Settingspannel.selectedItem
                          : ""
                      }`}
                    >
                      {" "}
                      <PiUserListLight />
                      User List
                    </li>
                  </Link>
                )}

                {checkCondition?.group?.includes("view") && (
                  <Link to="/group">
                    <li
                      className={`${Settingspannel.settingsListItem} ${
                        isSelected("/group") ? Settingspannel.selectedItem : ""
                      }`}
                    >
                      {" "}
                      <GrGroup />
                      Groups
                    </li>
                  </Link>
                )}

                {checkCondition?.channel?.includes("view") && (
                  <Link to="/channel">
                    <li
                      className={`${Settingspannel.settingsListItem} ${
                        isSelected("/channel")
                          ? Settingspannel.selectedItem
                          : ""
                      }`}
                    >
                      {" "}
                      <CgHashtag />
                      Channel
                    </li>
                  </Link>
                )}
              </>
            ) : (
              <></>
            )}
            <Link to="/privacy-policy">
              <li
                className={`${Settingspannel.settingsListItem} ${
                  isSelected("/privacy-policy")
                    ? Settingspannel.selectedItem
                    : ""
                }`}
              >
                <MdOutlinePrivacyTip />
                Privacy Policy
              </li>
            </Link>
            <Link to="/aboutus">
              <li
                className={`${Settingspannel.settingsListItem} ${
                  isSelected("/aboutus") ? Settingspannel.selectedItem : ""
                }`}
              >
                <IoIosInformationCircleOutline />
                About
              </li>
            </Link>
            {/* <li className={Settingspannel.settingsListItem}>
              <Link>
                <IoIosNotificationsOutline />
                Notification
              </Link>
            </li> */}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SettingsBar;
